/**
 * Interstitial module entry point.
 *
 * Auto-initializes interstitial redirect, sign-in and clipboard behavior
 * on DOMContentLoaded. Loaded via the reskin webpack pack on all
 * reskin pages but only activates when the relevant DOM elements
 * are present (interstitial pages).
 */

import { initInterstitialRedirect } from "./interstitial-redirect";
import { initInterstitialSignin } from "./interstitial-signin";
import { initInterstitialClipboard } from "./interstitial-clipboard";

function init() {
  initInterstitialRedirect();
  initInterstitialSignin();
  initInterstitialClipboard();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
